export default __webpack_public_path__ + "static/media/bannerCrisBarros.3b0eee13.svg";